import fetch from "@/utils/request";

import { getBrowser } from "@/utils/browser";
import jsBridge from "@/utils/jsBridge";

export default {
  login(data?: object): any {
    return fetch({
      url: "/php/api/auth/login",
      method: "post",
      data
    });
  },

  Check_phone(data?: object): any {
    return fetch({
      url: "/php/api/auth/phone",
      method: "get",
      data
    });
  },
  // 新登录
  authV2LoginApi(data?: object): any {
    const isApp = getBrowser().isApp;
    const headers = isApp
      ? {}
      : {
          post: {
            platform: "app",
            "gf-deviceNo": sessionStorage.getItem("device_no") || "",
            "gf-system": sessionStorage.getItem("sysyem") || "",
            "gf-version": sessionStorage.getItem("version") || "",
            "gf-device": sessionStorage.getItem("device") || "",
            "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
            "gf-network": sessionStorage.getItem("network") || "",
            "gf-clientVersion": sessionStorage.getItem("key") || ''
          }
        };
    return fetch({
      url: "/php/api/auth/v2/login",
      method: "post",
      data,
      headers
    });
  },
  authV2LoginApi2(data?: object): any {
    return fetch({
      url: "/php/api/auth/v2/login",
      method: "post",
      data,
      headers: {
        post: {
          platform: "maH5",
          "gf-deviceNo": sessionStorage.getItem("device_no") || "",
          "gf-system": sessionStorage.getItem("sysyem") || "",
          "gf-version": sessionStorage.getItem("version") || "",
          "gf-device": sessionStorage.getItem("device") || "",
          "gf-clientTypes": sessionStorage.getItem("clientTypes") || "",
          "gf-network": sessionStorage.getItem("network") || "",
          "gf-clientVersion": sessionStorage.getItem("key") || ''
        }
      }
    });
  },
  // 获取登录方式
  getToolsSystemParams(data?: object): any {
    return fetch({
      url: "/php/api/tools/system/param",
      method: "get",
      data,
      timeout: 500,
      customLoading: true,
      hideFailMessage: true
    });
  },
  // 指纹登录
  authLoginV2FingerprintApi(data?: object, headers?: object): any{
    return fetch({
      url: "/php/api/auth/login/v2/fingerprint",
      method: "get",
      data,
      headers
    });
  },
  // 区号列表
  getAreaCodeLists(data?: object): any {
    return fetch({
      url: "/php/api/tools/get_area_code_lists",
      method: "get",
      data
    });
  },

};
